import { render, staticRenderFns } from "./AthleteReportsAdminDashboard.vue?vue&type=template&id=2941ea27&"
import script from "./AthleteReportsAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./AthleteReportsAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports